import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardLayout, LoginLayout } from "../layouts";
import { Dashboard } from "../pages";
import Login from "../pages/Login/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import NotFound from "../pages/404/404";
import UserManagement from "../pages/User_Management/UserManagment";
import { AddOrUpdateUser } from "../pages/User_Management/AddOrUpdateUser";
import MemberProfileNew from "../pages/User_Management/MemberProfileNew";
import AdsList from "../pages/AdsList/AdsList";
import { AddOrUpdateAds } from "../pages/AdsList/AddOrUpdateAds";
import PaymentRequest from "../pages/Payment/PaymentRequest";
import PaymentRequestDetail from "../pages/Payment/PaymentRequestDetail";
import AgencyAdAccounts from "../pages/Payment/AgencyAdAccounts";
import TransactionsList from "../pages/Payment/TransactionsList";
import WalletTransactionsList from "../pages/Payment/WalletTransactionsList";
import AppealDisabledAccount from "../pages/Payment/AppealDisabledAccount";
import TopUpFunds from "../pages/Payment/TopUpFunds";
import ClearAccountFunds from "../pages/Payment/ClearAccountFunds";
import DepositHistory from "../pages/Payment/DepositHistory";
import DefaultSetting from "../pages/DefaultSetting";
import EmployeeManagement from "../pages/EmployeeManagement/EmployeeManagement";
import { AddOrUpdateEmploye } from "../pages/EmployeeManagement/AddOrUpdateEmploye";
import BusinessCenter from "../pages/BusinessCenter/BusinessCenter";
import { AddOrUpdateBusinessCenter } from "../pages/BusinessCenter/AddOrUpdateBusinessCenter";
import AffiliatePayoutRequest from "../pages/Payment/AffiliatePayoutRequest";
import SupportTicket from "../pages/SupportTickets/SupportTicket";
import SupportTicketDetail from "../pages/SupportTickets/SupportTicketDetail";
import { StripeSettings } from "../pages/StripeSettings";
import ManageSpendings from "../pages/Spendings/ManageSpendings";
import { CancelSubscripiton } from "../pages/CancelSubscription/CancelSubscripiton";
import { AuthorizationCC } from "../pages/CC Authorization/AuthorizationCC";
import { ClearWalletBalance } from "../pages/Clear Wallet Balance/ClearWalletBalance";
import { DetailsClearWallet } from "../pages/Clear Wallet Balance/components/DetailsClearWallet";

export default function Routers() {
  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route
          path="/user-management/add-user"
          element={<AddOrUpdateUser type={"add"} />}
        />
        <Route
          path="/user-management/edit-user/:id"
          element={<AddOrUpdateUser type={"edit"} />}
        />
        <Route path="/employee-management" element={<EmployeeManagement />} />
        <Route
          path="/employee-management/add-employee"
          element={<AddOrUpdateEmploye type={"add"} />}
        />
        <Route
          path="/employee-management/edit-employee/:id"
          element={<AddOrUpdateEmploye type={"edit"} />}
        />
        <Route path="/business-center" element={<BusinessCenter />} />
        <Route
          path="/business-center/add-business"
          element={<AddOrUpdateBusinessCenter type={"add"} />}
        />
        <Route
          path="/business-center/edit-business/:id"
          element={<AddOrUpdateBusinessCenter type={"edit"} />}
        />
        <Route
          path="/user-management/user-profile/:id"
          element={<MemberProfileNew />}
        />
        <Route path="/product-list" element={<AdsList />} />
        <Route
          path="/product-list/add-product"
          element={<AddOrUpdateAds type={"add"} />}
        />
        <Route
          path="/product-list/edit-product/:id"
          element={<AddOrUpdateAds type={"edit"} />}
        />
        <Route
          path="/user-management/user-profile/:id/agency-ad-accounts"
          element={<AgencyAdAccounts profile={true} />}
        />
        <Route
          path="/wallet-transactions"
          element={<WalletTransactionsList />}
        />
        <Route path="/general-settings" element={<DefaultSetting />} />
        <Route
          path="/appeal-disabled-account"
          element={<AppealDisabledAccount />}
        />
        <Route path="/top-up-funds" element={<TopUpFunds />} />
        <Route path="/clear-account-funds" element={<ClearAccountFunds />} />
        <Route path="/transactions-list" element={<TransactionsList />} />
        <Route path="/agency-accounts" element={<AgencyAdAccounts />} />
        <Route
          path="/affiliate-payout-request"
          element={<AffiliatePayoutRequest />}
        />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/stripe-settings" element={<StripeSettings />} />
        <Route path="/support-ticket/:id" element={<SupportTicketDetail />} />
        <Route path="/deposit-request" element={<PaymentRequest />} />
        <Route path="/manage-business-manager" element={<PaymentRequest />} />
        <Route
          path="/deposit-request/deposit-detail/:id"
          element={<PaymentRequestDetail />}
        />
        {/* <Route
          path="/deposit-request/deposit-detail/:id"
          element={<PaymentRequestDetail />}
        /> */}
        <Route
          path="/wallet-transactions/wallet-transaction-history/:id"
          element={<DepositHistory />}
        />
        <Route
          path="/dashboard/deposit-detail/:id"
          element={<PaymentRequestDetail dashbaord={true} />}
        />
        {/* <Route path="/manage-spendings/:id" element={<ManageSpendings />} /> */}
        <Route
          path="/cancel-subscription-requests"
          element={<CancelSubscripiton />}
        />
        <Route path="/cc-authorization" element={<AuthorizationCC />} />
        <Route path="/clear-wallet-balance" element={<ClearWalletBalance />} />
        <Route
          path="/clear-wallet-balance/details/:id"
          element={<DetailsClearWallet />}
        />
      </Route>

      {/* Public routes */}
      <Route element={<LoginLayout />}>
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Fallback to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/page-not-found" replace />} />
      <Route path="/page-not-found" element={<NotFound />} />
    </Routes>
  );
}
